import { render, staticRenderFns } from "./eventModal.vue?vue&type=template&id=251376d5&lang=html&"
import script from "./eventModal.vue?vue&type=script&lang=js&"
export * from "./eventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports